import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  Flex,
  Grid,
  MultiSelect,
  Select,
  Tabs,
  Text,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { IconCalendarMonth, IconCheck, IconX } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { formatToVietnamTz } from "../../../../_base/extension/DateExtension";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import { MessageResponse } from "../../../../model/MessageResponse";
import { CustomerGroup } from "../../../../model/TblDmCustomer";
import {
  tblPromotion,
  tblPromotionCommand,
} from "../../../../model/TblPromotion";
import { getTblDmEmployeeSelect } from "../../../../service/getSelectApi";
import { validateCreatePromotion } from "../../../../validate/UserCreateModelValidator";
import CustomersV2 from "./Components/SetupPromotionPolicy/CustomersV2";
import OrtherConditions from "./Components/SetupPromotionPolicy/OtherConditions";
import SaleChannel from "./Components/SetupPromotionPolicy/SaleChannel";
import SuperMarket from "./Components/SetupPromotionPolicy/SuperMarket";
import TableItemAddOnPromotion from "./Components/TableItemPromotion/TableItemAddOnPromotion";
import TableItemGiftPromotion from "./Components/TableItemPromotion/TableItemGiftPromotion";
import TableItemPrimaryPromotion from "./Components/TableItemPromotion/TableItemPrimaryPromotion";
import { PromotionalDescriptionV2 } from "../CreatePromotionPolicy/Components/TableItemPromotion/PromotionalDescriptionV2";

const EditPromotionPolicyV2 = () => {
  const navigate = useNavigate();
  let params = useParams();
  const [selectedPolicyType, setSelectedPolicyType] = useState<string>("0");
  const [userSelect, setUserSelect] = useState<SelectListItemBase[]>([]);
  const [successCall, setSuccessCall] = useState<boolean>(false);

  // State riêng để lưu nội dung mô tả khuyến mãi
  const [promotionDescription, setPromotionDescription] = useState<{
    moTa: string | null;
    moTaTemp: string | null;
    moTaConfirmed: boolean;
  }>({
    moTa: null,
    moTaTemp: null,
    moTaConfirmed: false,
  });

  //Xử lý đa điều kiện
  const location = useLocation();
  const isMultiCondition = location.state && location.state.multiCondition;
  const dataPaymentMethod = [
    { value: "all", label: "Tất cả" },
    {
      value: "offline",
      label: "Thanh toán khi nhận hàng",
    },
    {
      value: "online",
      label: "Thanh toán bằng chuyển khoản",
    },
    {
      value: "card",
      label: "Thanh toán bằng thẻ quốc tế Visa, Master",
    },
  ];

  const [entity, setEntity] = useState<tblPromotion>({
    tblPromotionCommand: {
      id: 0,
      code: null,
      type: "0",
      createDate: null,
      createBy: null,
      stopTriggerRule: null,
      note: null,
      moTa: null,
      moTaTemp: null,
      moTaConfirmed: null,
      approveDate: null,
      approveBy: null,
      approveStatus: null,
      approveNote: null,
      priority: null,
      checkRewardPoint: null,
      checkNomalPromote: null,
      checkMixPromote: null,
      listPaymentMethod: null,
      listSaleChanel: null,
      attribute1: null,
      attribute2: null,
      attribute3: null,
      attribute4: null,
      attribute5: null,
      attribute6: null,
      attribute7: null,
      attribute8: null,
      attribute9: null,
      attribute10: null,
      attribute11: null,
      attribute12: null,
      attribute13: null,
      attribute14: null,
      attribute15: null,
      listCustGroup: [],
      lisItemPrimary: [],
      listBranch: "",
      ismultiple: false,
    },

    tblPromotionItemPrimaryCommands: [],
    tblPromotionItemAddOnCommands: [],
    tblPromotionItemGiftCommands: [],
  });

  const form = useForm<tblPromotion>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {},
  });

  const formHeader = useForm<tblPromotionCommand>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity.tblPromotionCommand,
    },
    validate: validateCreatePromotion,
  });

  const checkAllItemsExist = (arrayCheck: string[]): boolean => {
    const allValuesFromA = dataPaymentMethod
      .filter((item) => item.value !== "all")
      .map((item) => item.value);

    return allValuesFromA.every((value) => arrayCheck.includes(value));
  };

  const backHome = () => {
    navigate("/config-system/config-promotion-policy");
    localStorage.removeItem("policyType");
  };

  const handleCreatePromotion = async (dataSubmit: tblPromotion) => {
    try {
      if (
        !dataSubmit.tblPromotionCommand?.effDate ||
        !dataSubmit.tblPromotionCommand?.expDate
      ) {
        NotificationExtension.Warn("Vui lòng chọn khoảng thời gian hiệu lực !");
        return;
      }

      const url = "/api/v1/TblPromotion/edit";

      const dataApi = await repositoryPos.post<MessageResponse<boolean>>(
        url,
        dataSubmit,
      );
      if (dataApi && dataApi.success) {
        NotificationExtension.Success("Chỉnh sửa CTKM thành công !");
        setTimeout(() => {
          navigate("/config-system/config-promotion-policy");
        }, 2000);
      } else NotificationExtension.Fails(dataApi?.message || "Thất bại");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("params", params);
    if (!params.id || Number.parseInt(params.id) < 1) {
      navigate("/process-defs/flow-model");
    } else {
      if (isMultiCondition) {
        fetchDataPromotionMultiCondition();
      } else {
        fetchDataCreatePromotion(Number.parseInt(params.id));
      }
    }
  }, []);

  useEffect(() => {
    if (selectedPolicyType) {
      form.setFieldValue("tblPromotionCommand.type", selectedPolicyType);
    }
  }, [selectedPolicyType]);

  const [dataInittt, setDataInittt] = useState<tblPromotion>(entity);

  const fetchDataCreatePromotion = async (id: number) => {
    const dataApi = await repositoryPos.get<MessageResponse<tblPromotion>>(
      "/api/v1/TblPromotion/edit?promotionId=" + id,
    );
    if (dataApi && dataApi.success) {
      setEntity(dataApi.data);
      //  form.setFieldValue("tblPromotionCommand.code", dataApi.data?.tblPromotionCommand.c);
      formHeader.setValues(dataApi.data.tblPromotionCommand);
      formHeader.resetDirty(dataApi.data.tblPromotionCommand);
      formHeader.initialize(dataApi.data.tblPromotionCommand);
      dataApi.data.tblPromotionCommand.listCustGroup = JSON.parse(
        dataApi.data.tblPromotionCommand.listCustGroup as string,
      ) as CustomerGroup[];
      // listBranch giữ nguyên dạng chuỗi id để gửi thẳng lại khi lưu

      setDataInittt(dataApi.data);
      if (dataApi.data.tblPromotionCommand.effDate) {
        formHeader.setFieldValue(
          "effDate",
          new Date(dataApi.data.tblPromotionCommand.effDate),
        );
      }

      if (
        dataApi.data.tblPromotionCommand.listPaymentMethod &&
        dataApi.data.tblPromotionCommand.listPaymentMethod?.includes(",")
      ) {
        formHeader.setFieldValue(
          "listPaymentMethod",
          String(dataApi.data.tblPromotionCommand.listPaymentMethod).split(","),
        );
      } else if (dataApi.data.tblPromotionCommand.listPaymentMethod) {
        formHeader.setFieldValue(
          "listPaymentMethod",
          dataApi.data.tblPromotionCommand.listPaymentMethod
            ? [String(dataApi.data.tblPromotionCommand.listPaymentMethod)]
            : [],
        );
      }

      if (
        dataApi.data.tblPromotionCommand.listSaleChanel &&
        dataApi.data.tblPromotionCommand.listSaleChanel?.includes(",")
      ) {
        formHeader.setFieldValue(
          "listSaleChanel",
          String(dataApi.data.tblPromotionCommand.listSaleChanel)?.split(","),
        );
      } else if (dataApi.data.tblPromotionCommand.listSaleChanel) {
        formHeader.setFieldValue(
          "listSaleChanel",
          dataApi.data.tblPromotionCommand.listSaleChanel
            ? [String(dataApi.data.tblPromotionCommand.listSaleChanel)]
            : [],
        );
      }

      if (dataApi.data.tblPromotionCommand.countDownDate) {
        formHeader.setFieldValue(
          "countDownDate",
          new Date(dataApi.data.tblPromotionCommand.countDownDate),
        );
      }

      if (dataApi.data.tblPromotionCommand.expDate) {
        formHeader.setFieldValue(
          "expDate",
          new Date(dataApi.data.tblPromotionCommand.expDate),
        );
      }

      if (dataApi.data.tblPromotionCommand.createBy)
        formHeader.setFieldValue(
          "createBy",
          dataApi.data.tblPromotionCommand.createBy.toString(),
        );

      if (dataApi.data.tblPromotionCommand.attribute1) {
        try {
          setListPromotion(
            dataApi.data.tblPromotionCommand.attribute1.split(","),
          );
        } catch (error) {}
      }

      // Map từ attribute vào moTa, moTaTemp, moTaConfirmed
      // if (dataApi.data.tblPromotionCommand.attribute2) {
      //   formHeader.setFieldValue(
      //     "moTa",
      //     dataApi.data.tblPromotionCommand.attribute2,
      //   );
      //   formHeader.setFieldValue("moTaConfirmed", true);
      //   setPromotionDescription((prev) => ({
      //     ...prev,
      //     moTa: dataApi.data.tblPromotionCommand.attribute2,
      //     moTaConfirmed: true,
      //   }));
      // }
      // if (dataApi.data.tblPromotionCommand.attribute11) {
      //   formHeader.setFieldValue(
      //     "moTaTemp",
      //     dataApi.data.tblPromotionCommand.attribute11,
      //   );
      //   setPromotionDescription((prev) => ({
      //     ...prev,
      //     moTaTemp: dataApi.data.tblPromotionCommand.attribute11,
      //   }));
      // }
      // if (dataApi.data.tblPromotionCommand.attribute12) {
      //   const confirmed =
      //     dataApi.data.tblPromotionCommand.attribute12 === "true";
      //   formHeader.setFieldValue("moTaConfirmed", confirmed);
      //   setPromotionDescription((prev) => ({
      //     ...prev,
      //     moTaConfirmed: confirmed,
      //   }));
      // }

      if (dataApi.data.tblPromotionCommand.moTa) {
        formHeader.setFieldValue("moTa", dataApi.data.tblPromotionCommand.moTa);
        formHeader.setFieldValue("moTaConfirmed", true);
        formHeader.setValues((prev) => ({
          ...prev,
          moTa: dataApi.data.tblPromotionCommand.moTa,
          moTaTemp: dataApi.data.tblPromotionCommand.moTa,
          moTaConfirmed: true,
        }));
        setPromotionDescription((prev) => ({
          ...prev,
          moTa: dataApi.data.tblPromotionCommand.moTa || null,
          moTaTemp: dataApi.data.tblPromotionCommand.moTa || null,
          moTaConfirmed: true,
        }));
      }

      setSuccessCall(true);

      // console.log(22, dataApi.data);
    } else {
      NotificationExtension.Fails("Bạn không có quyền thực hiện thao tác");
      navigate("/config-system/config-promotion-policy");
    }
  };

  const fetchDataPromotionMultiCondition = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblPromotion/edit-multiple?promotionId=${params.id}`,
    );

    if (res && res.success) {
      const result = res.data;
      formHeader.setValues({
        ...result?.tblPromotion,
        effDate: new Date(result?.tblPromotion?.effDate),
        expDate: new Date(result?.tblPromotion?.expDate),
        createBy: String(result?.tblPromotion?.createBy),
      });
    }
  };

  const [selectType, setTypeSelect] = useState<SelectListItemBase[]>([]);

  useEffect(() => {
    fetchUser();
    getTypeSelect();
  }, []);

  const getTypeSelect = async () => {
    var resType = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblPromotion/type");
    if (resType?.httpStatusCode === 200 && resType.data) {
      setTypeSelect(resType.data);
    }
  };

  const fetchUser = async () => {
    const dataseApi = await getTblDmEmployeeSelect();
    setUserSelect(dataseApi);
  };

  const _styleGrid = { base: 12, md: 6, lg: 2 };

  const [listPromotion, setListPromotion] = useState<string[]>([]);

  return (
    <Box
      component="form"
      onSubmit={formHeader.onSubmit(async (e) => {
        if (formHeader.validate().hasErrors) {
          NotificationExtension.Fails("Vui lòng điền đầy đủ thông tin !");
          return;
        }

        // Kiểm tra mô tả khuyến mại: nếu đã nhập nội dung nhưng chưa xác nhận thì chặn lưu
        const moTaTemp = promotionDescription.moTaTemp ?? "";
        const moTaConfirmed = promotionDescription.moTaConfirmed ?? false;
        if (
          moTaTemp &&
          moTaTemp.replace(/<[^>]*>/g, "").trim().length > 0 &&
          !moTaConfirmed
        ) {
          NotificationExtension.Fails(
            "Vui lòng xác nhận nội dung mô tả khuyến mại trước khi lưu.",
          );
          return;
        }

        let _data = form.getValues();

        if (
          _data &&
          _data.tblPromotionItemPrimaryCommands &&
          _data.tblPromotionItemPrimaryCommands.length > 0 &&
          !_data.tblPromotionItemPrimaryCommands.every(
            (item: any) => item.attribute3 && Number(item.attribute3) > 0,
          )
        ) {
          NotificationExtension.Fails(
            "Vui lòng nhập đầy đủ số lượng áp dụng !",
          );
          return;
        }

        // Lấy tất cả giá trị từ formHeader, bao gồm cả các trường động như moTa
        const formHeaderValues = (formHeader as any).getValues();
        console.log("FormHeader values:", {
          moTa: formHeaderValues?.moTa,
          moTaTemp: formHeaderValues?.moTaTemp,
          moTaConfirmed: formHeaderValues?.moTaConfirmed,
          all: formHeaderValues,
        });

        console.log("=== DEBUG promotionDescription state ===");
        console.log("promotionDescription:", promotionDescription);

        _data.tblPromotionCommand = {
          ...formHeader.getValues(),
          // Sử dụng state thay vì dựa vào formHeader.getValues()
          moTa: promotionDescription.moTa,
          moTaTemp: promotionDescription.moTaTemp,
          moTaConfirmed: promotionDescription.moTaConfirmed,
        };

        console.log("After assign tblPromotionCommand:", {
          moTa: _data.tblPromotionCommand?.moTa,
          moTaTemp: _data.tblPromotionCommand?.moTaTemp,
          moTaConfirmed: _data.tblPromotionCommand?.moTaConfirmed,
        });

        _data.tblPromotionCommand.effDate = formatToVietnamTz(
          _data.tblPromotionCommand.effDate,
        );
        _data.tblPromotionCommand.expDate = formatToVietnamTz(
          _data.tblPromotionCommand.expDate,
        );
        _data.tblPromotionCommand.countDownDate = formatToVietnamTz(
          _data.tblPromotionCommand.countDownDate
            ? new Date(_data.tblPromotionCommand.countDownDate)
            : undefined,
        );
        _data.tblPromotionCommand.listPaymentMethod = Array.isArray(
          _data.tblPromotionCommand.listPaymentMethod,
        )
          ? _data.tblPromotionCommand.listPaymentMethod.join(",")
          : _data.tblPromotionCommand.listPaymentMethod;
        if (listPromotion.length > 0) {
          _data.tblPromotionCommand.ismultiple = listPromotion.length > 0;
          _data.tblPromotionCommand.attribute1 = listPromotion.join(",");
        }
        _data.tblPromotionCommand.attribute6 =
          _data.tblPromotionCommand.type !== "4"
            ? "false"
            : _data.tblPromotionCommand.attribute6;

        if (_data.tblPromotionCommand.type !== "1") {
          _data.tblPromotionItemAddOnCommands = [];
          _data.tblPromotionItemGiftCommands = [];
          _data.tblPromotionItemPrimaryCommands =
            _data.tblPromotionItemPrimaryCommands &&
            Array.isArray(_data.tblPromotionItemPrimaryCommands) &&
            _data.tblPromotionItemPrimaryCommands.length > 0
              ? _data.tblPromotionItemPrimaryCommands.map((item) => ({
                  ...item,
                  discountPercent: null,
                  itemPrimaryName:
                    item.itemPrimaryName && item.itemPrimaryName.length > 100
                      ? String(item.itemPrimaryName).slice(0, 100) + " ..."
                      : item.itemPrimaryName,
                }))
              : [];
        } else {
          _data.tblPromotionItemPrimaryCommands =
            _data.tblPromotionItemPrimaryCommands?.map((item) => ({
              ...item,
              attribute5: null,
              itemPrimaryName:
                item.itemPrimaryName && item.itemPrimaryName.length > 100
                  ? String(item.itemPrimaryName).slice(0, 100) + " ..."
                  : item.itemPrimaryName,
            }));
          _data.tblPromotionItemAddOnCommands =
            _data.tblPromotionItemAddOnCommands &&
            Array.isArray(_data.tblPromotionItemAddOnCommands) &&
            _data.tblPromotionItemAddOnCommands.length > 0
              ? _data.tblPromotionItemAddOnCommands?.map((item) => ({
                  ...item,
                  itemAddOnName:
                    item.itemAddOnName && item.itemAddOnName.length > 100
                      ? String(item.itemAddOnName).slice(0, 100) + " ..."
                      : item.itemAddOnName,
                }))
              : [];
          _data.tblPromotionItemGiftCommands =
            _data.tblPromotionItemGiftCommands &&
            Array.isArray(_data.tblPromotionItemGiftCommands) &&
            _data.tblPromotionItemGiftCommands.length > 0
              ? _data.tblPromotionItemGiftCommands?.map((item) => ({
                  ...item,
                  itemGiftName:
                    item.itemGiftName && item.itemGiftName.length > 100
                      ? String(item.itemGiftName).slice(0, 100) + " ..."
                      : item.itemGiftName,
                  itemPrimaryName:
                    item.itemPrimaryName && item.itemPrimaryName.length > 100
                      ? String(item.itemPrimaryName).slice(0, 100) + " ..."
                      : item.itemPrimaryName,
                }))
              : [];
        }

        if (_data.tblPromotionCommand.approveStatus !== "1") {
          _data.tblPromotionItemPrimaryCommands =
            _data.tblPromotionItemPrimaryCommands &&
            Array.isArray(_data.tblPromotionItemPrimaryCommands) &&
            _data.tblPromotionItemPrimaryCommands.length > 0
              ? _data.tblPromotionItemPrimaryCommands?.map((item) => {
                  const { isNotDelete, ...rest } = item;
                  return rest;
                })
              : [];
          _data.tblPromotionItemGiftCommands =
            _data.tblPromotionItemGiftCommands &&
            Array.isArray(_data.tblPromotionItemGiftCommands) &&
            _data.tblPromotionItemGiftCommands.length > 0
              ? _data.tblPromotionItemGiftCommands?.map((item) => {
                  const { isNotDelete, ...rest } = item;
                  return rest;
                })
              : [];
          _data.tblPromotionItemAddOnCommands =
            _data.tblPromotionItemAddOnCommands &&
            Array.isArray(_data.tblPromotionItemAddOnCommands) &&
            _data.tblPromotionItemAddOnCommands.length > 0
              ? _data.tblPromotionItemAddOnCommands?.map((item) => {
                  const { isNotDelete, ...rest } = item;
                  return rest;
                })
              : [];
        }

        _data.tblPromotionCommand.attribute4 = null;

        // Debug: Check giá trị trước khi map
        console.log("=== TRƯỚC KHI MAP VÀO ATTRIBUTE ===");
        console.log("moTa type:", typeof _data.tblPromotionCommand.moTa);
        console.log("moTa value:", _data.tblPromotionCommand.moTa);
        console.log(
          "moTaTemp type:",
          typeof _data.tblPromotionCommand.moTaTemp,
        );
        console.log("moTaTemp value:", _data.tblPromotionCommand.moTaTemp);
        console.log(
          "moTaConfirmed type:",
          typeof _data.tblPromotionCommand.moTaConfirmed,
        );
        console.log(
          "moTaConfirmed value:",
          _data.tblPromotionCommand.moTaConfirmed,
        );

        // Map moTa vào các attribute có sẵn vì backend có thể không hỗ trợ field mới
        _data.tblPromotionCommand.attribute2 =
          _data.tblPromotionCommand.moTa || null;
        _data.tblPromotionCommand.attribute11 =
          _data.tblPromotionCommand.moTaTemp || null;
        _data.tblPromotionCommand.attribute12 = _data.tblPromotionCommand
          .moTaConfirmed
          ? "true"
          : "false";

        console.log("=== SAU KHI MAP VÀO ATTRIBUTE ===");
        console.log("attribute2:", _data.tblPromotionCommand.attribute2);
        console.log("attribute11:", _data.tblPromotionCommand.attribute11);
        console.log("attribute12:", _data.tblPromotionCommand.attribute12);

        delete _data.promotionConditionMultiples;
        await handleCreatePromotion(_data);
      })}
    >
      <Flex
        align={"center"}
        gap={"md"}
        justify={"space-between"}
        px={"3px"}
        wrap={"wrap"}
      >
        <Text size={"16px"} tt={"uppercase"} fw={"bold"}>
          Chỉnh sửa chính sách khuyến mãi
        </Text>
        <Flex gap={"md"}>
          <Button
            variant="outline"
            color="red"
            leftSection={<IconX size={14} />}
            onClick={backHome}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            variant="outline"
            color="teal"
            leftSection={<IconCheck size={14} />}
          >
            Lưu chính sách
          </Button>
        </Flex>
      </Flex>
      <Grid>
        <Grid.Col span={12} h={"max-content"}>
          <Box h={"max-content"}>
            <Fieldset legend="Thông tin chung">
              <Grid>
                <Grid.Col span={_styleGrid}>
                  <TextInput
                    label="Mã CTKM"
                    placeholder="Nhập Mã CTKM"
                    variant="filled"
                    readOnly
                    withAsterisk
                    key={formHeader.key("code")}
                    {...formHeader.getInputProps("code")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <Select
                    key={formHeader.key("createBy")}
                    label="Người lập"
                    placeholder="Vui lòng chọn..."
                    nothingFoundMessage="Không có dữ liệu"
                    variant="filled"
                    readOnly
                    limit={1}
                    data={userSelect.map((doctype) => ({
                      value: doctype.value,
                      label: doctype.text,
                    }))}
                    searchable
                    withAsterisk
                    {...formHeader.getInputProps("createBy")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <Select
                    label="Chính sách khuyến mại"
                    placeholder="Vui lòng chọn..."
                    nothingFoundMessage="Không có dữ liệu"
                    data={[
                      ...(selectType
                        .filter((item) => String(item.value) !== "3")
                        .map((x) => ({
                          value: x.value,
                          label: x.text,
                        })) || []),
                      { label: "Deal sốc", value: "4" },
                    ]}
                    searchable
                    withAsterisk
                    value={formHeader.getValues()?.type}
                    {...formHeader.getInputProps("type")}
                    onChange={(e) => {
                      if (e !== "4") {
                        formHeader.setFieldValue("type", e ? e : "");
                      } else {
                        const effDate = new Date(
                          formHeader.getValues()?.effDate ?? "",
                        );
                        const nextDay = new Date(effDate);
                        nextDay.setDate(effDate.getDate() + 1);
                        nextDay.setHours(0, 0, 0, 0);
                        nextDay.setSeconds(nextDay.getSeconds() - 1);

                        formHeader.setValues((prev) => ({
                          ...prev,
                          type: e ? e : "",
                          expDate: new Date(nextDay),
                        }));
                      }
                    }}
                    variant={
                      formHeader.getValues().approveStatus !== "1"
                        ? "filled"
                        : "default"
                    }
                    readOnly={formHeader.getValues().approveStatus !== "1"}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Thời gian bắt đầu đếm ngược"
                    placeholder="Thời gian bắt đầu đếm ngược"
                    minDate={new Date()}
                    locale="vi"
                    rightSection={<IconCalendarMonth size={14} />}
                    clearable
                    key={formHeader.key("countDownDate")}
                    {...formHeader.getInputProps("countDownDate")}
                    variant={
                      formHeader.getValues().approveStatus !== "1"
                        ? "filled"
                        : "default"
                    }
                    readOnly={formHeader.getValues().approveStatus !== "1"}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Hiệu lực từ ngày"
                    placeholder="Hiệu lực từ ngày"
                    minDate={new Date()}
                    locale="vi"
                    rightSection={<IconCalendarMonth size={14} />}
                    withAsterisk
                    clearable
                    value={
                      formHeader.getValues()?.effDate
                        ? new Date(formHeader.getValues()?.effDate ?? "")
                        : null
                    }
                    {...formHeader.getInputProps("effDate")}
                    onChange={(e) => {
                      if (formHeader.getValues()?.type !== "4") {
                        formHeader.setFieldValue("effDate", new Date(e ?? ""));
                      } else {
                        const effDate = new Date(e ?? "");
                        const nextDay = new Date(effDate);
                        nextDay.setDate(effDate.getDate() + 1);
                        nextDay.setHours(0, 0, 0, 0);
                        nextDay.setSeconds(nextDay.getSeconds() - 1);

                        formHeader.setValues((prev) => ({
                          ...prev,
                          effDate: new Date(e ?? ""),
                          expDate: new Date(nextDay),
                        }));
                      }
                    }}
                    variant={
                      formHeader.getValues().approveStatus !== "1"
                        ? "filled"
                        : "default"
                    }
                    readOnly={formHeader.getValues().approveStatus !== "1"}
                  />
                </Grid.Col>

                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Đến ngày"
                    placeholder="Đến ngày"
                    locale="vi"
                    withAsterisk
                    clearable
                    minDate={
                      formHeader.getValues().effDate
                        ? new Date(
                            dayjs(formHeader.getValues().effDate)
                              .add(0, "day")
                              .toDate(),
                          )
                        : new Date()
                    }
                    maxDate={
                      formHeader.getValues()?.type === "4" &&
                      formHeader.getValues().effDate
                        ? (() => {
                            const effDate = new Date(
                              formHeader.getValues().effDate ?? "",
                            );
                            const nextDay = new Date(effDate);
                            nextDay.setDate(effDate.getDate() + 1);
                            nextDay.setHours(0, 0, 0, 0);
                            nextDay.setSeconds(nextDay.getSeconds() - 1);
                            return nextDay;
                          })()
                        : undefined
                    }
                    rightSection={<IconCalendarMonth size={14} />}
                    key={formHeader.key("expDate")}
                    {...formHeader.getInputProps("expDate")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 2 }}>
                  <MultiSelect
                    label="Chọn phương thức thanh toán"
                    placeholder="Vui lòng chọn phương thức thanh toán"
                    nothingFoundMessage="Không có dữ liệu"
                    data={dataPaymentMethod}
                    searchable
                    value={
                      formHeader.getValues()?.listPaymentMethod &&
                      Array.isArray(formHeader.getValues()?.listPaymentMethod)
                        ? formHeader.getValues()?.listPaymentMethod
                        : []
                    }
                    {...formHeader.getInputProps("listPaymentMethod")}
                    onChange={(e) => {
                      if (
                        (e?.includes("all") &&
                          e.indexOf("all") === e.length - 1) ||
                        checkAllItemsExist(e)
                      ) {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: ["all"],
                        }));
                      } else if (
                        e?.includes("all") &&
                        e.indexOf("all") === 0 &&
                        e.length > 1
                      ) {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: e
                            ? e.filter((item) => item !== "all")
                            : [],
                        }));
                      } else {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: e ? e : [],
                        }));
                      }
                    }}
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                  <Select
                    key={formHeader.key("attribute3")}
                    label="Áp dụng"
                    placeholder="Chọn trình duyệt áp dụng"
                    data={[
                      { label: "Áp dụng đồng thời POS và Web", value: "1" },
                      { label: "Chỉ áp dụng trên POS", value: "2" },
                      { label: "Chỉ áp dụng trên Web", value: "3" },
                    ]}
                    {...formHeader.getInputProps("attribute3")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 8 }}>
                  <TextInput
                    label="Tên CTKM"
                    placeholder="Tên CTKM"
                    withAsterisk
                    key={formHeader.key("note")}
                    {...formHeader.getInputProps("note")}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    label="Ghi chú"
                    placeholder="Nhập ghi chú"
                    key={formHeader.key("attribute5")}
                    {...formHeader.getInputProps("attribute5")}
                  />
                </Grid.Col>
              </Grid>
              <Grid mt={5}>
                <Grid.Col span={12}>
                  <Flex justify={"start"} align={"center"} gap={"md"}>
                    <Checkbox
                      key={formHeader.key("ismultiple")}
                      label="Áp dụng đồng thời CTKM khác"
                      {...formHeader.getInputProps("ismultiple", {
                        type: "checkbox",
                      })}
                    />
                    {formHeader.getValues()?.type === "4" && (
                      <Checkbox
                        label="Mỗi số điện thoại chỉ được áp dụng 1 lần"
                        checked={formHeader.getValues()?.attribute6 === "true"}
                        onClick={() =>
                          formHeader.setValues((prev) => ({
                            ...prev,
                            attribute6:
                              formHeader.getValues()?.attribute6 &&
                              formHeader.getValues()?.attribute6 === "true"
                                ? "false"
                                : "true",
                          }))
                        }
                      />
                    )}
                  </Flex>
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Box>
        </Grid.Col>

        <Grid.Col span={12}>
          <Tabs
            defaultValue={"primary"}
            styles={{
              tabLabel: { fontWeight: 700, fontSize: 13 },
              panel: {
                overflowX: "visible",
              },
            }}
          >
            <Tabs.List>
              <Tabs.Tab value="primary">Mặt hàng chính</Tabs.Tab>
              {formHeader.getValues()?.type === "1" ? (
                <>
                  <Tabs.Tab value="gift">Mặt hàng tặng</Tabs.Tab>
                  <Tabs.Tab disabled={selectedPolicyType === "2"} value="addOn">
                    Mặt hàng mua kèm
                  </Tabs.Tab>
                </>
              ) : (
                <></>
              )}
              <Tabs.Tab value="branch&customer">
                Chi nhánh áp dụng và khách hàng
              </Tabs.Tab>
              <Tabs.Tab value="PromotionDescription">Mô tả khuyến mãi</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="otherConditions">
              <OrtherConditions />
            </Tabs.Panel>

            <Tabs.Panel value="primary">
              <TableItemPrimaryPromotion
                form={form}
                dataInit={entity.tblPromotionItemPrimaryCommands ?? []}
                typePromotion={formHeader.getValues()?.type ?? ""}
                approveStatus={formHeader.getValues()?.approveStatus ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="gift">
              <TableItemGiftPromotion
                form={form}
                dataInit={entity.tblPromotionItemGiftCommands ?? []}
                approveStatus={formHeader.getValues()?.approveStatus ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="addOn">
              <TableItemAddOnPromotion
                dataInit={entity.tblPromotionItemAddOnCommands ?? []}
                form={form}
                approveStatus={formHeader.getValues()?.approveStatus ?? ""}
              />
            </Tabs.Panel>

            <Tabs.Panel value="branch&customer">
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Fieldset legend={"Chi nhánh áp dụng"} mt={10}>
                    <SuperMarket
                      form={formHeader}
                      _data={dataInittt.tblPromotionCommand.listBranch}
                    />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Fieldset legend="Đối tượng khách hàng" mt={10}>
                    <CustomersV2
                      form={formHeader}
                      _data={dataInittt.tblPromotionCommand.listCustGroup as []}
                    />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Fieldset legend={"Kênh bán áp dụng"} mt={10}>
                    <SaleChannel form={formHeader} successCall={successCall} />
                  </Fieldset>
                </Grid.Col>
              </Grid>
            </Tabs.Panel>

            <Tabs.Panel value="PromotionDescription">
              <PromotionalDescriptionV2
                formHeader={formHeader}
                dataPromotionDetail={{
                  dataDetail: entity,
                  method: "EDIT",
                }}
                onDescriptionChange={(moTa, moTaTemp, moTaConfirmed) => {
                  setPromotionDescription({
                    moTa,
                    moTaTemp,
                    moTaConfirmed,
                  });
                }}
              />
            </Tabs.Panel>
          </Tabs>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default EditPromotionPolicyV2;
